import { render, staticRenderFns } from "./CreateLinkPopover.vue?vue&type=template&id=95fc0f16"
import script from "./CreateLinkPopover.vue?vue&type=script&lang=js"
export * from "./CreateLinkPopover.vue?vue&type=script&lang=js"
import style0 from "./CreateLinkPopover.vue?vue&type=style&index=0&id=95fc0f16&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports